export const coachWorkRoutineKeys = {
    all: ['coachWorkRoutine'] as const,
    list: (centerId: string, year: string, month: string) =>
        [...coachWorkRoutineKeys.all, 'list', centerId, year, month] as const,
};
